'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = defineResources;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _actions2 = require('../actions');

var actions = _interopRequireWildcard(_actions2);

var _helpers = require('../helpers');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function defineResources(mapStateToResources) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$pure = _ref.pure,
      pure = _ref$pure === undefined ? true : _ref$pure;

  return function (WrappedComponent) {
    var _class, _temp;

    var ReduxConnectComponent = (0, _reactRedux.connect)(function () {
      return {};
    }, null, null, { pure: pure })(WrappedComponent);

    var TptConnectComponent = (_temp = _class = function (_ReduxConnectComponen) {
      _inherits(TptConnectComponent, _ReduxConnectComponen);

      /**
       * @override
       */
      function TptConnectComponent() {
        _classCallCheck(this, TptConnectComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        // our resource props we will eventually pass down to the rendered component
        var _this = _possibleConstructorReturn(this, _ReduxConnectComponen.call.apply(_ReduxConnectComponen, [this].concat(args)));

        _this.resourceProps = {};

        // keep in array as well for easier access
        _this.allResources = [];

        // the state props managed by redux
        _this._reduxStateProps = {};

        _this.updateOptionsIfNeeded();
        return _this;
      }

      TptConnectComponent.prototype.componentWillMount = function componentWillMount() {
        var isServer = this.options.isServer;
        // gotta call it once before triggering fetch

        this.haveResourcePropsChanged = this.updateResourcePropsIfNeeded();
        // trigger fetch of all resources before first render (cant be in render
        // method since it triggers a setState on prepopulate)
        this.fetchResources(isServer ? this.serverResources : this.allResources);
      };

      TptConnectComponent.prototype.componentDidUpdate = function componentDidUpdate() {
        this.fetchResources(this.changedResources);
      };

      TptConnectComponent.prototype.fetchResources = function fetchResources(resources) {
        var _this2 = this;

        resources.forEach(function (resource) {
          var definition = resource.definition;

          if (definition.auto && !(0, _helpers.isInState)(_this2.state.storeState, definition)) {
            resource.prepopulate();
            resource.fetch().catch(function () {
              /* we dont expose the promise here, so we should probably catch
               * those rejections to prevent unhandled rejections */
            });
          }
        });
      };

      TptConnectComponent.prototype.updateOptionsIfNeeded = function updateOptionsIfNeeded() {
        if (!this.haveOwnPropsChanged) {
          return false;
        }
        var _props = this.props,
            isServer = _props.isServer,
            onRequest = _props.onRequest,
            onSuccess = _props.onSuccess,
            onError = _props.onError;

        this.options = _extends({ isServer: isServer, onRequest: onRequest, onSuccess: onSuccess, onError: onError }, this.context.options);
        this.updateDispatchers();
        return true;
      };

      /**
       * @override
       */


      TptConnectComponent.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
        // reinstate reudx's stateProps here so we dont get false
        // `haveStatePropsChanged` when they havent
        this.stateProps = this._reduxStateProps;

        var haveStatePropsChanged = _ReduxConnectComponen.prototype.updateStatePropsIfNeeded.call(this);

        // keep ref to redux's stateProps
        this._reduxStateProps = this.stateProps;

        this.haveResourcePropsChanged = this.updateResourcePropsIfNeeded();

        // overwriting to include our resourceProps as well before redux renders
        this.stateProps = _extends({}, this.stateProps, this.resourceProps);

        // if this is just a tpt-connect component, we can prevent triggering a
        // re-render if resourceProps stayed the same
        return this.haveResourcePropsChanged || haveStatePropsChanged;
      };

      // updating dispatching funcs is only necessary when options changed and
      // we need to bind new (anti-pattern...) callbacks


      TptConnectComponent.prototype.updateDispatchers = function updateDispatchers() {
        var _options = this.options,
            onSuccess = _options.onSuccess,
            onError = _options.onError,
            onRequest = _options.onRequest;

        var _bindActionCreators = (0, _redux.bindActionCreators)(actions, this.store.dispatch),
            invalidateResource = _bindActionCreators.invalidateResource,
            prepopulateResource = _bindActionCreators.prepopulateResource,
            dispatchRequest = _bindActionCreators.dispatchRequest;

        // TODO no need to update these two


        this.invalidateResource = invalidateResource;
        this.prepopulateResource = prepopulateResource;

        // wrapping in a function returning a normal promise
        this.dispatchRequest = function (definition) {
          var promise = new Promise(function (resolve, reject) {
            dispatchRequest(definition, {
              onSuccess: (0, _helpers.extendFunction)(onSuccess, resolve),
              onError: (0, _helpers.extendFunction)(onError, reject)
            });
          });
          onRequest && onRequest(promise);
          return promise;
        };
      };

      TptConnectComponent.prototype.updateResourcePropsIfNeeded = function updateResourcePropsIfNeeded() {
        var _this3 = this;

        var nextResourceProps = this.computeResourceProps();
        var resourceKeys = Object.keys(nextResourceProps);

        if (resourceKeys.every(function (k) {
          return _this3.resourceProps[k] && // new prop is currently defined
          !nextResourceProps[k].definition._isDirty && ( // new prop does not need to be fetched

          // resource did not update (error or success)
          nextResourceProps[k].meta.lastUpdated === _this3.resourceProps[k].meta.lastUpdated ||
          // new resource is still fetching
          nextResourceProps[k].meta.isFetching);
        })) {
          return false;
        }

        this.resourceProps = nextResourceProps;

        this.allResources = resourceKeys.map(function (k) {
          return _this3.resourceProps[k];
        });

        this.changedResources = this.allResources.filter(function (_ref2) {
          var definition = _ref2.definition;
          return definition._isDirty;
        });

        this.serverResources = this.allResources.filter(function (_ref3) {
          var definition = _ref3.definition;
          return !definition.clientOnly;
        });

        return true;
      };

      TptConnectComponent.prototype.computeResourceProps = function computeResourceProps() {
        var _this4 = this;

        var resourceDefinitions = mapStateToResources(this.state.storeState, _extends({}, this.props, this._reduxStateProps));

        return Object.keys(resourceDefinitions).reduce(function (resourceProps, key) {
          var _extends2;

          var oldResource = _this4.resourceProps[key] || {};
          var definition = (0, _helpers.normalizeResourceDefinition)(resourceDefinitions[key]);

          // used to figure out if we should refetch our resource
          var _isDirty = !oldResource.definition || // new resource
          definition.auto && !oldResource.definition.auto || // auto prop changed from false to true
          definition.requestKey !== oldResource.definition.requestKey;

          var _ref4 = (0, _helpers.findInState)(_this4.state.storeState, definition) || {},
              _ref4$meta = _ref4.meta,
              meta = _ref4$meta === undefined ? {} : _ref4$meta,
              _ref4$value = _ref4.value,
              value = _ref4$value === undefined ? definition.defaultValue : _ref4$value;

          return _extends({}, resourceProps, (_extends2 = {}, _extends2[key] = _extends({
            definition: _extends({}, definition, {
              _isDirty: _isDirty,
              _timerId: oldResource.definition && oldResource.definition._timerId
            }),
            meta: meta,
            value: value,
            invalidate: function invalidate() {
              return _this4.invalidateResource(definition);
            },
            prepopulate: function prepopulate() {
              return _this4.prepopulateResource(definition);
            },
            fetch: function fetch() {
              return _this4.dispatchRequest(definition);
            }
          }, _this4.computeResourceActions(definition)), _extends2));
        }, {});
      };

      TptConnectComponent.prototype.computeResourceActions = function computeResourceActions(resourceDefinition) {
        var _this5 = this;

        var resourceActions = resourceDefinition.actions;

        return Object.keys(resourceActions).reduce(function (_actions, actionKey) {
          var _extends3;

          var action = typeof resourceActions[actionKey] === 'function' ? resourceActions[actionKey] : function () {
            return resourceActions[actionKey];
          };

          return _extends({}, _actions, (_extends3 = {}, _extends3[actionKey] = function () {
            var actionDefinition = _extends({}, resourceDefinition, {
              updateStrategy: false,
              refetchAfter: false
            }, action.apply(undefined, arguments));
            var refetchAfter = actionDefinition.refetchAfter;

            var url = (0, _helpers.fullUrl)(actionDefinition.url, actionDefinition.params);
            return _this5.dispatchRequest(_extends({}, actionDefinition, { url: url })).then(function (response) {
              if (refetchAfter === 'success' || refetchAfter === true) {
                _this5.dispatchRequest(resourceDefinition);
              }
              return Promise.resolve(response);
            }).catch(function (err) {
              if (refetchAfter === 'error' || refetchAfter === true) {
                _this5.dispatchRequest(resourceDefinition);
              }
              return Promise.reject(err);
            });
          }, _extends3));
        }, {});
      };

      return TptConnectComponent;
    }(ReduxConnectComponent), _class.contextTypes = _extends({}, ReduxConnectComponent.contextTypes, {
      options: _propTypes2.default.object
    }), _temp);


    TptConnectComponent.displayName = 'TptConnect(' + (WrappedComponent.displayName || WrappedComponent.name) + ')';

    TptConnectComponent.WrappedComponent = WrappedComponent;

    return (0, _hoistNonReactStatics2.default)(TptConnectComponent, WrappedComponent);
  };
}
module.exports = exports['default'];